"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ButtonOrLink = _interopRequireDefault(require("../private/ButtonOrLink"));
var _styles = require("./styles");
var _AppLoader = _interopRequireDefault(require("../AppLoader"));
var _react2 = require("@emotion/react");
var _IconChevronLeft = _interopRequireDefault(require("../../icons/General/IconChevronLeft"));
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const Button = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
    danger,
    success,
    highlight,
    disabled,
    outline,
    afterIcon,
    beforeIcon,
    border,
    nostyle,
    css,
    loading,
    back,
    small,
    transparentBg,
    focusable,
    tabIndex,
    ...restProps
  } = props;
  const theme = (0, _react2.useTheme)();
  const accessibilityProps = {};
  const getLoaderColor = () => {
    if (!outline && !transparentBg || success) return theme.btnDefaultFontColor;
    if (danger) return theme.btnDanger;
    return theme.secondary;
  };
  if (loading) {
    accessibilityProps['aria-busy'] = props.loading;
    accessibilityProps['aria-disabled'] = props.loading;
    accessibilityProps['aria-live'] = props['aria-live'] || 'polite';
    accessibilityProps['aria-label'] = props['aria-label'] || 'Laster';
  }
  if (disabled) {
    accessibilityProps['aria-disabled'] = props.disabled;
  }
  if (back) {
    accessibilityProps['aria-label'] = props['aria-label'] || 'Gå tilbake';
  }
  return (0, _jsxRuntime.jsx)(_ButtonOrLink.default, {
    tabIndex: tabIndex,
    disabled: disabled,
    loading: loading,
    ref: ref,
    css: theme => [_styles.styles.default(theme), outline && _styles.styles.outline(theme), danger && _styles.styles.danger(theme), success && _styles.styles.success(theme), highlight && _styles.styles.highlighted, disabled && _styles.styles.disabled(theme), (beforeIcon || afterIcon) && _styles.styles.icon(theme), beforeIcon && _styles.styles.beforeIcon, afterIcon && _styles.styles.afterIcon, border && _styles.styles.border(border), nostyle && _styles.styles.nostyle, loading && _styles.styles.loading(theme), back && _styles.styles.back(theme), css && css, small && _styles.styles.small, danger && outline && _styles.styles.dangerOutline(theme), success && outline && _styles.styles.successOutline(theme), transparentBg && _styles.styles.transparentBg, focusable && _styles.styles.focusable],
    afterIcon: afterIcon,
    beforeIcon: back ? (0, _jsxRuntime.jsx)(_IconChevronLeft.default, {
      size: '12px'
    }) : beforeIcon,
    ...accessibilityProps,
    ...restProps,
    children: loading ? (0, _jsxRuntime.jsx)(_AppLoader.default, {
      color: getLoaderColor()
    }) : props.children
  });
});
var _default = exports.default = Button;